import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { CityComponent } from '../city/city.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-city-list',
  templateUrl: './city-list.component.html',
  styleUrls: ['./city-list.component.css']
})
export class CityListComponent implements OnInit {

  public menu_item_id = '4';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['city_name', 'city_name_en', 'country_name', 'country_name_en', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<CityComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'city', 'city_name': '', 'city_name_en': '', 'country_id': '0', 'comment': '' };
  country = [];

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = this.queryList.all_country;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.country = data.data['list'];
      });
  }

  search() {

    let condition = "";
    // `city`.`country_id` = '" + this.model['country_id'] + "') AND 
    if (this.model['city_name'] != '')
      condition += " (`city_name` LIKE '%" + this.model['city_name'] +
        "%' OR `city_name_en` LIKE '%" + this.model['city_name'] + "%') AND ";

    let query = "SELECT `city`.*, `country`.`country_name`, `country`.`country_name_en` FROM `city`, `country` WHERE " + 
      condition + "`city`.`country_id` = `country`.`country_id` AND `city`.`status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newcityEntry() {
    this.addDialogRef = this.dialog.open(CityComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['status'] == 'success')
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }
  editCity(row) {
    //alert(row.city_id);
    let dialog_data = {
      'table_name': 'city', 'city_id': row.city_id,
      'city_name': row.city_name,
      'city_name_en': row.city_name_en, 'country_id': row.country_id, 'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(CityComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delCity(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'city_id': row.city_id }];
      //console.log(values);
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }
}
